<template>
  <van-swipe :autoplay="3000" indicator-color="white">
    <van-swipe-item v-for="item in list" :key="item.id"><img :src="item.url" alt=""></van-swipe-item>
  </van-swipe>
</template>

<script>
  export default {
    name: 'MrSwipe',
    props: {
      list: {
        type: Array,
        default: () => []
      }
    }
  }
</script>

<style lang="scss" scoped>
img{
  width: 100%;
  height: 200px;
  object-fit: cover;
}
</style>
